import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import {AuthService} from './Services'
import {MeasureService} from './Services/MeasureService'
import ConfigService from './Services/ConfigService'
import {LoaderStore} from './Stores/LoaderStore'
import {AppStore} from './Stores/AppStore'
import { LanguageService } from './Services/LanguageService';

const rootEl = document.getElementById('root')
export const loaderStore = new LoaderStore()
export const config = ConfigService.getConfig()
export const authService = new AuthService()
export const measureService = new MeasureService()
export const languageService = new LanguageService()
export const appStore = new AppStore()

const renderCallback = async () => {
    const loader = document.getElementById('react-app-loader')
    if (loader) {
        loaderStore.appLoaderElement = loader
        loader.addEventListener('transitionend', () => {
            if (loader.classList.contains('hide')) {
                loader.classList.add('invisible')
            }
        }, true)
        await languageService.init()
        await authService.init()
        measureService.init()
        loaderStore.hideAppLoader(true)
    }
}

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    rootEl,
    renderCallback,
)
